import { Tooltip } from 'react-tooltip';
const AIWarningMessage = () => {
  return (
    <>
      <div
        className="bottom-2 left-2 bg-black bg-opacity-70 text-white text-xs p-2 rounded-md z-50"
        data-tooltip-id="ai-warning-message"
        data-tooltip-content="For any issues contact support@streamalive.com"
      >
        AI generated content may be incorrect.
      </div>
      <Tooltip
        id="ai-warning-message"
        place="top-start"
        style={{
          padding: '8px',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderRadius: '8px',
          fontSize: '14px',
        }}
      />
    </>
  );
};

export default AIWarningMessage;
